// extracted by mini-css-extract-plugin
export var videoCount = "videos-count-module--video-count--Sh9jl";
export var videoCountIcon = "videos-count-module--video-count-icon--Z4ouj";